import type { ElementType } from "react";
import { atom } from "jotai";

export interface GlobalModalOptions {
  /**
   * 弹窗唯一ID
   */
  id?: string | number;
  /**
   * 弹窗组件
   */
  Comp: ElementType;
  /**
   * 组件参数
   */
  params?: Record<string, any>;
  /**
   * 展示顺序，值越大，越快展示，默认为0
   */
  order?: number;
  /**
   * 点击空白是否关闭，默认false
   */
  clickOnClickOutside?: boolean;
  /**
   * 
   * @returns 关闭事件
   */
  onClose?: () => void;
}

// 全局弹窗列表
export const globalModalListAtom = atom<GlobalModalOptions[]>([]);